const FORMATO = new Intl.DateTimeFormat('es-CL', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'America/Santiago' })

/** '2026-09-29T14:03:00Z' → '29 sept 2026, 11:03' (hora de Chile). */
export function formatoFecha(iso: string | null | undefined): string {
  if (!iso) return '—'
  const fecha = new Date(iso)
  return Number.isNaN(fecha.getTime()) ? '—' : FORMATO.format(fecha)
}

const DIA = new Intl.DateTimeFormat('es-CL', { weekday: 'long', day: 'numeric', month: 'long' })
const DIA_CON_ANO = new Intl.DateTimeFormat('es-CL', { day: 'numeric', month: 'long', year: 'numeric' })

/** 'AAAA-MM-DD' como fecha local (sin corrimiento por zona horaria). */
export function diaLocal(iso: string): Date {
  const [a, m, d] = iso.split('-').map(Number)
  return new Date(a, m - 1, d)
}

/** 'AAAA-MM-DD' de una fecha local. */
export function isoDia(fecha: Date): string {
  const dos = (n: number) => String(n).padStart(2, '0')
  return `${fecha.getFullYear()}-${dos(fecha.getMonth() + 1)}-${dos(fecha.getDate())}`
}

/** '2026-11-02' → '2 de noviembre de 2026'. */
export function formatoDia(iso: string | null | undefined): string {
  return iso ? DIA_CON_ANO.format(diaLocal(iso)) : '—'
}

/** '2026-11-02' → 'lunes, 2 de noviembre'. */
export function formatoDiaSemana(iso: string): string {
  return DIA.format(diaLocal(iso))
}
